import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllPillCountDataService = async (
  pageNumber,
  pageSize,
  access_token,
  searchedPillCount = ""
) => {
  try {
    return axios.get(
      `${api}/PillCount/GetPillCount?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${searchedPillCount}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};
